export const act1 = {
  title: 'OBWIESZCZENIE MINISTRA SPRAWIEDLIWOŚCI W SPRAWIE WYSOKOŚCI ODSETEK USTAWOWYCH',
  desc: 'z dnia 7 stycznia 2016 r. (M.P. z 2016 r. poz. 46)',
  pars:[
    { text: 'Na podstawie art. 359 § 4 ustawy z dnia 23 kwietnia 1964 r. - Kodeks cywilny (Dz.U. z 2014 r. poz. 121, z późn. zm.1) ogłasza się, że poczynając od dnia 1 stycznia 2016 r. wysokość odsetek ustawowych wynosi 5% w stosunku rocznym.' },
  ]
};
export const act2 = {
  title: 'OBWIESZCZENIE MINISTRA SPRAWIEDLIWOŚCI W SPRAWIE WYSOKOŚCI ODSETEK USTAWOWYCH',
  desc: 'z dnia 14 lipca 2020 r. (M.P. z 2020 r. poz. 626)',
  pars1:[
    { text: 'Na podstawie art. 359 § 4 ustawy z dnia 23 kwietnia 1964 r. - Kodeks cywilny (Dz.U. z 2019 r. poz. 1145 i 1495 oraz z 2020 r. poz. 875) ogłasza się, co następuje:' },
    { text: '1) poczynając od:' },
  ],
  usts: [
    { text: 'a) dnia 9 kwietnia 2020 r. do dnia 28 maja 2020 r. wysokość odsetek ustawowych wynosiła 4% w stosunku rocznym,' },
    { text: 'b) dnia 18 marca 2020 r. do dnia 8 kwietnia 2020 r. wysokość odsetek ustawowych wynosiła 4,5% w stosunku rocznym;' },
  ],
  pars2:[
    { text: '2) poczynając od dnia 29 maja 2020 r. wysokość odsetek ustawowych wynosi 3,6% w stosunku rocznym.' },
  ],
};
export const act3 = {
  title: 'OBWIESZCZENIE MINISTRA SPRAWIEDLIWOŚCI W SPRAWIE WYSOKOŚCI ODSETEK USTAWOWYCH',
  desc: 'z dnia 18 października 2021 r (M.P. z 2021 r.Poz. 952)',
  pars:[
    { text: 'Na podstawie art. 359 § 4 ustawy z dnia 23 kwietnia 1964 r. – Kodeks cywilny (Dz. U. z 2020 r. poz. 1740 i 2320 oraz z 2021 r. poz. 1509) ogłasza się, że poczynając od dnia 7 października 2021 r. wysokość odsetek ustawowych wynosi 4% w stosunku rocznym.' },
  ]
};
export const act4 = {
  title: 'OBWIESZCZENIE MINISTRA SPRAWIEDLIWOŚCI W SPRAWIE WYSOKOŚCI ODSETEK USTAWOWYCH',
  desc: 'z dnia 29 listopada 2021 r (M.P. z 2021 r.Poz. 1096)',
  pars:[
    { text: 'Na podstawie art. 359 § 4 ustawy z dnia 23 kwietnia 1964 r. – Kodeks cywilny (Dz. U. z 2020 r. poz. 1740 i 2320 oraz z 2021 r. poz. 1509) ogłasza się, że poczynając od dnia 4 listopada 2021 r. wysokość odsetek ustawowych wynosi 4,75% w stosunku rocznym.' }
  ]
};

export const act5 = {
  title: 'OBWIESZCZENIE MINISTRA SPRAWIEDLIWOŚCI W SPRAWIE WYSOKOŚCI ODSETEK USTAWOWYCH',
  desc: 'z dnia 28 grudnia 2021 r (M.P. z 2021 r.Poz. 1201)',
  pars:[
    { text: 'Na podstawie art. 359 § 4 ustawy z dnia 23 kwietnia 1964 r. – Kodeks cywilny (Dz. U. z 2020 r. poz. 1740 i 2320 oraz z 2021 r. poz. 1509 i 2459) ogłasza się, że poczynając od dnia 9 grudnia 2021 r. wysokość odsetek ustawowych wynosi 5,25% w stosunku rocznym. ' }
  ]
};

export const act6 = {
  title: 'OBWIESZCZENIE MINISTRA SPRAWIEDLIWOŚCI W SPRAWIE WYSOKOŚCI ODSETEK USTAWOWYCH',
  desc: 'z dnia 24 stycznia 2022 r (M.P. z 2022 r.Poz. 110)',
  pars:[
    { text: 'Na podstawie art. 359 § 4 ustawy z dnia 23 kwietnia 1964 r. – Kodeks cywilny (Dz. U. z 2020 r. poz. 1740 i 2320oraz z 2021 r. poz. 1509 i 2459) ogłasza się, że poczynając od dnia 5 stycznia 2022 r. wysokość odsetek ustawowych wynosi 5,75% w stosunku rocznym.' }
  ]
};

export const act7 = {
  title: 'OBWIESZCZENIE MINISTRA SPRAWIEDLIWOŚCI W SPRAWIE WYSOKOŚCI ODSETEK USTAWOWYCH',
  desc: 'z dnia 23 lutego 2022 r (M.P. z 2022 r.Poz. 286)',
  pars:[
    { text: 'Na podstawie art. 359 § 4 ustawy z dnia 23 kwietnia 1964 r. – Kodeks cywilny (Dz. U. z 2020 r. poz. 1740 i 2320 oraz z 2021 r. poz. 1509 i 2459) ogłasza się, że poczynając od dnia 9 lutego 2022 r. wysokość odsetek ustawowych wynosi 6,25% w stosunku rocznym.' }
  ]
};

export const act8 = {
  title: 'OBWIESZCZENIE MINISTRA SPRAWIEDLIWOŚCI W SPRAWIE WYSOKOŚCI ODSETEK USTAWOWYCH',
  desc: 'z dnia 28 marca 2022 r (M.P. z 2022 r.Poz. 374)',
  pars:[
    { text: 'Na podstawie art. 359 § 4 ustawy z dnia 23 kwietnia 1964 r. – Kodeks cywilny (Dz. U. z 2020 r. poz. 1740 i 2320 oraz z 2021 r. poz. 1509 i 2459) ogłasza się, że poczynając od dnia 9 marca 2022 r. wysokość odsetek ustawowych wynosi 7% w stosunku rocznym.' }
  ]
};